import React from "react";
import { topSectionData, footerSection, NavSection } from "./HeaderAndFooter";
import { Helmet } from "react-helmet";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const contentSection = (
  <>
    <div class='dispfbanner'>
      <div class='bannerarea'>
        <h4 data-aos='zoom-in-down'>Policies</h4>
        <h1 data-aos='fade-up'>
          Privacy Policy, Terms & Conditions, & Cancellation Policy
        </h1>
        <div class='btarea' data-aos='zoom-in'></div>
      </div>
    </div>

  </>
);

const mainSection = (
  <>
    <main>

      <section class='image-section'>
        <img src='images/gallery/privacyPolicy.jpg' alt='privacy policy playall' style={{ width: '100%' }} />
      </section>

      <section class='image-section'>
        <img src='images/gallery/termsAndConditions.png' alt='terms and condition playall' style={{ width: '100%' }} />
      </section>

      <section class='image-section'>
        {/* <img src='images/gallery/cancellationPolicy.png' alt='cancellation policy' style={{ width: '100%' }} /> */}
        <div style={{ width: '100%', textAlign: 'left', padding: '16px', background: '#f9f9f9', borderRadius: '8px', marginTop: '16px' }}>
          <h1 style={{ textAlign: 'center', fontSize: '4rem' }}>Cancellation Policy</h1>
          <p style={{ fontSize: '1.2em' }}>At PlayAll Sports, we understand that plans can change, and we strive to accommodate our customers to the best of our ability. Please review our cancellation and reschedule policy below:</p>
          <ul>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Cancellation Policy:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Customers are eligible for a full refund or reschedule if the cancellation request is made at least 24 hours before the scheduled booking time.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Cancellations made within 24 hours of the booking time will not be eligible for a refund or reschedule.</li>
              </ul>
            </li>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Reschedule Policy:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Customers may request a reschedule of their booking at no additional cost if the request is made at least 24 hours before the scheduled booking time.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Rescheduling requests made within 24 hours of the booking time will be subject to availability and may incur additional charges.</li>
              </ul>
            </li>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Refund Process:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Refunds for eligible cancellations will be processed within 5 business days to the original payment method used for the booking.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Please note that it may take additional time for the refund to reflect in your account depending on your bank or payment provider.</li>
              </ul>
            </li>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>How to Cancel or Reschedule:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>To cancel or reschedule your booking, please log in to your PlayAll Sports account and navigate to the bookings section.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Select the booking you wish to cancel or reschedule and follow the prompts to complete the process.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Alternatively, you can contact our customer support team for assistance with cancellations or rescheduling requests.</li>
              </ul>
            </li>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Exceptions:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>In case of facility closures due to unforeseen circumstances such as inclement weather or maintenance issues, customers will be notified promptly, and reschedules will be offered.</li>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>PlayAll Sports reserves the right to cancel bookings in exceptional circumstances and provide reschedule in such cases.</li>
              </ul>
            </li>
            <li><strong style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>Contact Us:</strong>
              <ul>
                <li style={{ fontSize: '1.2em', marginBottom: '8px', display: 'inline-block' }}>If you have any questions or need further assistance regarding cancellations or rescheduling, please reach out to our customer support team at tech@playall.in.</li>
              </ul>
            </li>
          </ul>
          <p style={{ fontSize: '1.2em',   }}>
            By booking with PlayAll Sports, you acknowledge and agree to abide by the terms and conditions of our cancellation and reschedule policy outlined above.
          </p>
        </div>
      </section>



    </main>
  </>
);

const Policies = () => {
  return (
    <>

      <Helmet>
        <title>Policies</title>
        <meta name="description" content="Privacy Policy, Terms & Conditions, & Cancellation Policy" />
      </Helmet>
      <div style={{ overflowY: "scroll", height: "calc(100vh)" }}>
        {topSectionData}
        <div class='headbanner pickleBallBg' data-aos='fade'>
          <div class='container '>
            <NavSection />
            {contentSection}
          </div>
        </div>
        {mainSection}
        {footerSection}
      </div>
    </>
  );
};

export default Policies;
